import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgreementService {

  constructor(private http: HttpClient) { }

  get(agreementId: string) {
    return this.http.get<any>(environment.app.apiUrl + `agreement/${agreementId}`).toPromise();
  }

  search(criteria: any, from = 0, limit = 30) {
    return this.http.post<{ agreements: any[], total: number }>(environment.app.apiUrl + `agreement/search/${from}/${limit}`, criteria).toPromise();
  }
  getByUser(userId: string) {
    return this.http.get<any[]>(environment.app.apiUrl + `agreement/user/${userId}`).toPromise();
  }

  announce(agreementId: string, userIdOrPhone?: string) {
    return this.http.get<{ agreements: any[], total: number }>(environment.app.apiUrl +
      `agreement/announce/${agreementId}${userIdOrPhone ? '/' + userIdOrPhone : ''}`).toPromise();
  }
  edit(editAgreement: any) {
    return this.http.post<any>(environment.app.apiUrl + `agreement/edit`, editAgreement).toPromise();
  }
  testSign(code: any) {
    return this.http.post<any>(environment.app.apiUrl + `agreement/dev-set-sign/${code}`, null).toPromise();
  }

}
